import React from "react";
import { useCookies } from "react-cookie";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const [cookies] = useCookies(["accessToken"]);

  return cookies.accessToken ? <Outlet /> : <Navigate to="/sign-in" />;
};

export default ProtectedRoute;
